import KmxArrowRightFilled from '@kmx/mui-icons/KmxArrowRightFilled';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

interface QuestionLinkProps {
    url: string;
    question: string;
}

const QuestionLink = ({ url, question }: QuestionLinkProps) => (
    <Button
        href={url}
        color="secondary"
        sx={{ justifyContent: 'space-between', py: 3, px: 1 }}
        endIcon={<KmxArrowRightFilled color="primary" sx={{ ml: 3 }} />}
        fullWidth
        variant="text"
    >
        <Typography component="span" color="textPrimary">
            {question}
        </Typography>
    </Button>
);

export default QuestionLink;
